import script from "./calendarView.vue?vue&type=script&setup=true&lang=js"
export * from "./calendarView.vue?vue&type=script&setup=true&lang=js"

import "./calendarView.vue?vue&type=style&index=0&id=3f5d95c9&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f5d95c9"]])

export default __exports__